import colors from "core/resources/theme/colors";
import styled from "styled-components";

export const FieldContainer = styled.div<any>`
  width: 100%;
  
  .chakra-input {
    font-size: ${(props) => props.fontSize}px !important;
    transition: all 0.2s;
    opacity:${(props) => props.opacity} !important;
    cursor:${(props) => props.opacity ?' not-allowed' : ''} !important;
  }
  .chakra-input:hover:not(.unrequired-field),
  .chakra-input:focus:not(.unrequired-field) {
    border-color: ${(props) =>
      props.isInvalid ? colors.red : colors.primary} !important;
    box-shadow: 0 0 0 1px
      ${(props) => (props.isInvalid ? colors.red : colors.primary)} !important;
  }
  .chakra-input:hover:is(.unrequired-field),
  .chakra-input:focus:is(.unrequired-field),
  .chakra-input:hover:is(.valid-field),
  .chakra-input:focus:is(.valid-field) {
    border-color: ${colors.primary} !important;
    box-shadow: 0 0 0 1px ${colors.primary} !important;
  }
  
`;
